<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import DOMPurify from "isomorphic-dompurify";

  import spinner from "../images/brave-spinner.svg?raw";
  const trustedSpinner = DOMPurify.sanitize(spinner, { RETURN_TRUSTED_TYPE: true });

  export let showSpinner = true;

  let show = false;
  onMount(() => {
    const timer = setTimeout(() => (show = true), 800);

    return () => clearTimeout(timer);
  });
</script>

{#if show && showSpinner}
  <div in:fade={{ duration: 600 }} class="spinner flex flex-col items-center text-white">
    {@html trustedSpinner}
  </div>
{/if}

<style>
  :global {
    .brave-spinner {
      height: 100px;
      width: 100px;
    }

    .brave-spinner__path {
      -webkit-animation: brave-spin 3s linear 0s both infinite;
      animation: brave-spin 3s linear 0s both infinite;
    }

    /***************************************************
     * Partially generated by SVG Artista on 4/20/2021, 5:09:23 PM
     * MIT license (https://opensource.org/licenses/MIT)
     * W. https://svgartista.net
     **************************************************/

    @keyframes brave-spin {
      0% {
        stroke-dashoffset: 404;
        stroke-dasharray: 202.06;
      }

      100% {
        stroke-dashoffset: 0;
        stroke-dasharray: 202.06;
      }
    }

    @media only screen and (max-width: 600px) {
      .button-group {
        justify-items: center;
        grid-template-columns: repeat(1, 1fr);
      }
      .cta {
        order: -1;
      }
    }
  }
</style>
